<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ isEditMode() ? 'Editar Programa' : 'Nuevo Programa' }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica la información del programa' : 'Completa los datos para crear un nuevo programa' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button
          pButton
          type="button"
          [label]="isEditMode() ? 'Guardar Cambios' : 'Crear Programa'"
          [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-plus'"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading() || programaForm.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content edit-layout">
    <form [formGroup]="programaForm" (ngSubmit)="onSubmit()" id="programaForm" class="edit-form">
      <div class="app-card">
        <!-- Form Title -->
        <h2 class="text-xl font-semibold mb-6" style="color: hsl(var(--text));">
          {{ isEditMode() ? 'Datos del Programa' : 'Datos Generales' }}
        </h2>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Código -->
          <div class="space-y-2">
            <label for="codigo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Código
            </label>
            <input
              pInputText
              id="codigo"
              formControlName="codigo"
              type="text"
              placeholder="Ej: PROG-001"
              class="w-full"
              [class.border-red-500]="hasError('codigo', 'maxlength')"
            />
            @if (hasError('codigo', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('codigo') }}
              </small>
            }
          </div>

          <!-- Nombre -->
          <div class="space-y-2">
            <label for="nombre" class="text-sm font-medium" style="color: hsl(var(--text));">
              Nombre *
            </label>
            <input
              pInputText
              id="nombre"
              formControlName="nombre"
              type="text"
              placeholder="Ej: Programa de la Mañana"
              class="w-full"
              [class.border-red-500]="hasError('nombre', 'required') || hasError('nombre', 'maxlength')"
            />
            @if (hasError('nombre', 'required') || hasError('nombre', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('nombre') }}
              </small>
            }
          </div>

          <!-- Descripción -->
          <div class="space-y-2 md:col-span-2">
            <label for="descripcion" class="text-sm font-medium" style="color: hsl(var(--text));">
              Descripción *
            </label>
            <textarea
              pTextarea
              id="descripcion"
              formControlName="descripcion"
              rows="3"
              placeholder="Descripción detallada del programa"
              class="w-full"
              [class.border-red-500]="hasError('descripcion', 'required') || hasError('descripcion', 'maxlength')">
            </textarea>
            @if (hasError('descripcion', 'required') || hasError('descripcion', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('descripcion') }}
              </small>
            }
          </div>

          <!-- Conductores -->
          <div class="space-y-2 md:col-span-2">
            <label for="conductores" class="text-sm font-medium" style="color: hsl(var(--text));">
              Conductores
            </label>
            <textarea
              pTextarea
              id="conductores"
              formControlName="conductores"
              rows="4"
              placeholder="Ingrese los nombres de los conductores (uno por línea)"
              class="w-full">
            </textarea>
            <p class="text-xs" style="color: hsl(var(--muted));">
              Ingrese cada conductor en una línea separada
            </p>
          </div>

          <!-- Activo -->
          <div class="space-y-2 md:col-span-2">
            <div class="flex items-center gap-3">
              <p-toggleswitch
                inputId="activo"
                formControlName="activo">
              </p-toggleswitch>
              <label for="activo" class="text-sm font-medium cursor-pointer" style="color: hsl(var(--text));">
                Programa Activo
              </label>
            </div>
            <p class="text-xs" style="color: hsl(var(--muted));">
              Los programas activos están disponibles para su uso en el sistema
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
